import React, {Component} from 'react'
import QuoteIcon from '../QuoteIcon/QuoteIcon'

class ArticleBodyQuote extends Component {
  render () {
    const {children} = this.props
    return (
      <div className='ArticleBodyQuote'>
        <div className='ArticleBodyQuote__quoteIcon'>
          <QuoteIcon />
        </div>
        <p className='ArticleBodyQuote__text'>
          {children}
        </p>
      </div>
    )
  }
}

ArticleBodyQuote.defaultProps = {}

export default ArticleBodyQuote



// WEBPACK FOOTER //
// ./client/components/ArticleBodyQuote/ArticleBodyQuote.js